import { IMazeCell } from "./types";

/**
 * Returns the cell at coordinates (x, y) in the provided maze, or undefined if out of range.
 */
export function getCell(maze: IMazeCell[], x: number, y: number): IMazeCell | undefined {
  const cellX = Math.floor(x);
  const cellY = Math.floor(y);
  return maze.find((c) => c.x === cellX && c.y === cellY);
}

/**
 * Checks if there's a wall between cell (x1, y1) and (x2, y2).
 * Both coordinates are in floating-point, so we floor them to cell indices.
 * If the cells do not exist or if the relevant wall is set, returns true for "blocked."
 */
export function hasWallBetween(
  maze: IMazeCell[],
  x1: number,
  y1: number,
  x2: number,
  y2: number
): boolean {
  const cell1 = getCell(maze, x1, y1);
  const cell2 = getCell(maze, x2, y2);

  if (!cell1 || !cell2) {
    // If either cell doesn't exist, treat as blocked
    return true;
  }

  const cell1X = cell1.x;
  const cell1Y = cell1.y;
  const cell2X = cell2.x;
  const cell2Y = cell2.y;

  // If both are the same cell, no wall between them
  if (cell1X === cell2X && cell1Y === cell2Y) {
    return false;
  }

  // Movement directions:
  // 0: North, 1: East, 2: South, 3: West
  // Check difference
  if (cell2X > cell1X) {
    // East
    return cell1.walls[1];
  }
  if (cell2X < cell1X) {
    // West
    return cell1.walls[3];
  }
  if (cell2Y > cell1Y) {
    // South
    return cell1.walls[2];
  }
  if (cell2Y < cell1Y) {
    // North
    return cell1.walls[0];
  }

  // Default fallback
  return false;
}